module.exports = __webpack_public_path__ + "img/c468342.jpg";